module.exports = __webpack_public_path__ + "img/202502_01.81e602e4.jpg";